import { render, staticRenderFns } from "./LearningResources.vue?vue&type=template&id=76ca4521&scoped=true"
import script from "./LearningResources.vue?vue&type=script&lang=js"
export * from "./LearningResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ca4521",
  null
  
)

export default component.exports